import Picture from "@/components/common/Picture";
import CallToAction from "@/components/site-builder/CallToAction";
import CallToActionGroup from "@/components/site-builder/CallToActionGroup";
import TextField from "@/components/site-builder/TextField";
import { type FlexPosition } from "@/constants/content";
import type { ColumnTextBlock } from "../types";
import s from "./ColumnVariant1.module.scss";

export interface StandardColumnCardProps {
  block: ColumnTextBlock;
  buttonsAlignment: FlexPosition;
}

export default function ColumnVariant1(props: StandardColumnCardProps) {
  const {
    block: { image, title, body, buttons, displayCtaLinkOnImage },
    buttonsAlignment,
  } = props;
  const imageElement = <Picture imageConfig={image} />;

  return (
    <div className={s.wrapper}>
      {displayCtaLinkOnImage ? (
        <CallToAction config={buttons[0]} as="anchor">
          {imageElement}
        </CallToAction>
      ) : (
        imageElement
      )}
      <div className={s.body}>
        <div>
          <TextField field={title} type="header-h4" />
          <TextField field={body} type="text-regular" />
        </div>
        <div className={s.footer}>
          <CallToActionGroup buttons={buttons} position={buttonsAlignment} />
        </div>
      </div>
    </div>
  );
}
